import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { ThemeSelectors } from '../selectors/theme-selectors';
export var focusStyles = function (theme, additionalShadow) {
    var boxShadow = "0 0 0 2px ".concat(ThemeSelectors.getFocusColor(theme));
    var boxShadowValue = additionalShadow ? "".concat(boxShadow, " ").concat(additionalShadow) : boxShadow;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        outline: none;\n        box-shadow: ", ";\n    "], ["\n        outline: none;\n        box-shadow: ", ";\n    "])), boxShadowValue);
};
var templateObject_1;
